/**
 * Classe responsável por criar uma grid simples apenas para visualizacao de dados
 *
 * @author: kete
 */


Monet.UI = Monet.UI || {};
Monet.UI.TableViewCell = Monet.UI.TableViewCell || {};

Monet.UI.TableViewCell = (function () {

    function TableViewCell (type, value) {

        this.render = function () {

            var valueFormatted = "";

            if (type === 'ICON') {

                var item = { label: "", type: type };
                var fieldsRender = new Monet.UI.Fields.Render(item);

                var rendered = fieldsRender.render(item);
                rendered.setValue(value);
                valueFormatted = rendered.input.value;

            } else if (Monet.Format[type]) {
                valueFormatted = new Monet.Format[type](value).toGrid().getValue();
            }
            
            return valueFormatted;

        };

    }

    return TableViewCell;

})();